/**
 * @generated SignedSource<<f0d8da31a839c347c646bb84d29d9cc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGroupNumberTaskExecution_taskExecutionNumber$data = ReadonlyArray<{
  readonly goals: {
    readonly greaterThan: number | null;
    readonly lessThan: number | null;
  } | null;
  readonly id: string;
  readonly numberValue: number | null;
  readonly sectionId: string;
  readonly updatedAt: string | null;
  readonly " $fragmentType": "useGroupNumberTaskExecution_taskExecutionNumber";
}>;
export type useGroupNumberTaskExecution_taskExecutionNumber$key = ReadonlyArray<{
  readonly " $data"?: useGroupNumberTaskExecution_taskExecutionNumber$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGroupNumberTaskExecution_taskExecutionNumber">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useGroupNumberTaskExecution_taskExecutionNumber",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskNumberGoals",
      "kind": "LinkedField",
      "name": "goals",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lessThan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "greaterThan",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};

(node as any).hash = "729c4ded40599080b988b802800df238";

export default node;
